<!--<div *ngIf="gameUrl">-->
<!--  <iframe [src]="gameUrl" title="game" style="position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: 100%;" ></iframe>-->
<!--</div>-->


<main>
  <nav class="nav shadow bg-main py-0 game-iframe-bar">
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <div>
        <a routerLink=""><img src="{{assetsSource}}/{{logoFileName}}" [alt]="logoAltText"></a>
      </div>
      <div class="d-flex">
        <a type="button" routerLink="/account/cashier"><app-svg-icon class="variable-svg-icon" [pathIdentifier]="'cashier'"></app-svg-icon></a>
        <a type="button" (click)="toggleChat()"><app-svg-icon class="variable-svg-icon" [pathIdentifier]="'chat'"></app-svg-icon></a>
        <a type="button" routerLink="/details/{{gameIdentifier}}"><app-svg-icon class="variable-svg-icon" [pathIdentifier]="'close'"></app-svg-icon></a>
      </div>

    </div>
  </nav>
  <div *ngIf="gameUrl" class="game-iframe">
    <iframe [src]="gameUrl" title="game" style="position: absolute; top: 40px; left: 0; bottom: 0; right: 0; width: 100%; height: calc(100% - 40px);" ></iframe>
  </div>
</main>

